import { createTheme } from '@mui/material/styles';
import { blueGrey } from '@mui/material/colors'; // Keep if you want to reference blueGrey elsewhere

export const theme = createTheme({
  colorSchemes: {
    dark: {
      palette: {
        primary: {
          main: '#ec880d', // Custom orange for primary elements
        },
        background: {
          default: '#000000', // Darker background for dark mode
          paper: '#333', // Slightly lighter for paper components
        },
      },
    },
    light: {
      palette: {
        primary: {
          main: '#ec880d', // Same orange for consistency
        },
        background: {
          default: '#f5f5f5', // Light gray background
          paper: '#ffffff', // White for paper components
        },
      },
    },
  },
});
